{
  "search": {
    "search": "搜索",
    "openSearch": "打开搜索",
    "referenceSearch": "参考文档搜索",
    "referenceSearchResults": "参考文档搜索结果",
    "path": "路径：",
    "description": "描述：",
    "deprecated": "已弃用",
    "httpMethod": "HTTP 方法：",
    "required": "必填",
    "optional": "可选",
    "tagGroup": "标签组",
    "navigate": "导航",
    "select": "选择",
    "keyboardShortcut": "快捷键：",
    "command": "Command",
    "ctrl": "CTRL",
    "instructions": "按上方向键或下方向键导航，按回车选择，输入内容筛选结果",
    "entryTypes": {
      "heading": "标题",
      "operation": "接口",
      "tag": "标签",
      "model": "模型",
      "webhook": "Webhook"
    }
  },
  "agent": {
    "askAi": "询问 AI",
    "askAiAgent": "询问 AI 助手",
    "closeClient": "关闭客户端"
  },
  "common": {
    "copyLink": "复制链接",
    "copyLinkTo": "复制 {label} 的链接",
    "termsOfService": "服务条款",
    "authentication": "认证",
    "introduction": "简介",
    "server": "服务器：",
    "selectServer": "选择服务器",
    "default": "默认值",
    "example": "示例",
    "examples": "示例集",
    "type": "类型：",
    "format": "格式：",
    "pattern": "模式：",
    "models": "模型",
    "operations": "接口",
    "webhook": "Webhook",
    "webhooks": "Webhooks",
    "headers": "请求头",
    "cookies": "Cookies",
    "body": "请求体",
    "requestBody": "请求体",
    "responses": "响应",
    "required": "必填",
    "deprecated": "已弃用",
    "additionalProperties": "附加属性",
    "const": "常量：",
    "nullable": "可为空",
    "writeOnly": "仅写",
    "readOnly": "只读",
    "enum": "枚举",
    "emptyObject": "空对象",
    "collapsed": "已折叠",
    "showSchema": "显示 Schema",
    "status": "状态：",
    "noBody": "无内容",
    "selectedContentType": "已选内容类型：",
    "testRequest": "调试请求",
    "downloadOpenApiDocument": "下载 OpenAPI 文档",
    "more": "更多",
    "selectFromAllClients": "从全部客户端中选择",
    "fileFormatJson": "json",
    "fileFormatYaml": "yaml",
    "showMore": "显示更多",
    "openMenu": "打开菜单",
    "closeMenu": "关闭菜单",
    "sidebarFor": "{title} 的侧边栏",
    "openApiDocumentationFor": "{title} 的 OpenAPI 文档",
    "endpointsForTag": "{tag} 的端点",
    "showAllEndpoints": "显示 {tag} 的全部端点"
  },
  "operation": {
    "pathParameters": "路径参数",
    "queryParameters": "查询参数",
    "description": "接口描述",
    "copyEndpointUrl": "复制接口地址",
    "callbacks": "回调",
    "showHeaders": "显示请求头",
    "hideHeaders": "隐藏请求头",
    "showAdditionalProperties": "显示附加属性",
    "childAttributes": "子属性",
    "showChildAttributes": "显示{name}",
    "hideChildAttributes": "隐藏{name}"
  },
  "schema": {
    "unknownType": "未知类型"
  },
  "language": {
    "selectLanguage": "选择语言"
  },
  "developerTools": {
    "title": "开发者工具",
    "titleDescription": "开发者工具允许你自定义文档的外观和行为，也可以通过 Scalar Registry 分享你的文档。",
    "disableToolbarPrefix": "如果要禁用工具栏，请在配置中设置",
    "disableToolbarSuffix": "",
    "copyToClipboard": "复制到剪贴板",
    "localhostOnly": "开发者工具仅会在 localhost 环境下显示。",
    "configure": "配置",
    "scalarConfiguration": "Scalar 配置",
    "theme": "主题",
    "layout": "布局",
    "layoutOptions": "布局选项",
    "share": "分享",
    "shareApiReference": "分享你的 API Reference",
    "shareDescription": "上传你的 OpenAPI 文档，与他人分享 API Reference，点击按钮即可完成。",
    "deploy": "部署",
    "scalarDocs": "Scalar Docs",
    "deployDescription": "将你的文档部署到 Scalar，这是一套面向 API 和更多内容的现代文档平台。",
    "generate": "生成",
    "deployOnScalar": "部署到 Scalar",
    "deployForFree": "免费部署你的文档。",
    "additionalFeaturesMightRequire": "部分附加功能可能需要",
    "scalarPro": "Scalar Pro",
    "uploadDocument": "上传文档",
    "temporaryLinkExpiry": "你的文档会在 7 天后自动删除。",
    "unableToExportActiveDocument": "无法导出当前文档",
    "unknownError": "发生未知错误",
    "generateMcp": "生成 MCP",
    "connectMcp": "连接 MCP",
    "showSidebar": "显示侧边栏",
    "defaultOpenFirstTag": "默认展开首个标签",
    "defaultOpenAllTags": "默认展开所有标签",
    "expandAllModelSections": "展开所有模型分组",
    "expandAllResponses": "展开所有响应",
    "hideClientButton": "隐藏客户端按钮",
    "hideDarkModeToggle": "隐藏暗色模式切换",
    "hideModels": "隐藏模型",
    "hideSearch": "隐藏搜索",
    "showOperationId": "显示 Operation ID",
    "hideTestRequestButton": "隐藏测试请求按钮",
    "passwordProtection": "密码保护",
    "customDomains": "自定义域名",
    "freeFormContent": "自由内容页",
    "cdnInfrastructure": "CDN 基础设施",
    "pullFromGithub": "从 GitHub 拉取",
    "markdownMdx": "Markdown/MDX",
    "spectralLinting": "Spectral 规则检查",
    "jsonSchemaHosting": "JSON Schema 托管"
  },
  "gettingStarted": {
    "title": "Swagger 编辑器",
    "description": "欢迎使用 Scalar API References + Swagger Editor。这是一个免费开源工具，可以读取你的 Swagger/OAS 文件并生成精美的 API 文档。",
    "showExample": "查看示例",
    "uploadFile": "上传文件",
    "integrations": "集成",
    "theming": "主题",
    "features": "特性",
    "featureCustomizeTitle": "自定义",
    "featureCustomizeDescription": "使用你的字体与配色方案，或直接采用我们的主题。",
    "featureTestingTitle": "调试",
    "featureTestingDescription": "深度集成的 REST API Client，同样免费且开源。",
    "featureSearchTitle": "搜索",
    "featureSearchDescription": "完整集成搜索能力（基于 fuse.js）。",
    "featureHostingTitle": "托管",
    "featureHostingDescription": "在 https://apidocumentation.com 免费获得子域名托管。",
    "featureOpenApiTitle": "OpenAPI 与 Swagger",
    "featureOpenApiDescription": "支持 OpenAPI 3.1、OpenAPI 3.0 和 Swagger 2.0。",
    "featureCodeSamplesTitle": "代码示例",
    "featureCodeSamplesDescription": "为常见语言生成 API 调用代码示例。",
    "integrationsList": {
      "fastify": "Fastify",
      "cdn": "CDN",
      "vue": "Vue",
      "react": "React"
    }
  }
}
